import type { IntlShape } from 'react-intl'

import { createSelector } from '@app/utils/createSelector'

import { getIntlService } from '@app/store/actions/contexts/intlService'
import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

export const intlSlice = createReduxSlice<IntlShape>('intl').serialize(
  () => undefined,
  () => undefined
)

export const intlSelector = createSelector([intlSlice.selector], intl => {
  if (!intl) throw new Error('IntlService is not initialized')
  return intl
})

export const mergeIntlMessages = (extra: Record<string, string>) =>
  createThunk((dispatch, getState) => {
    if (Object.keys(extra).length === 0) return
    const intlService = dispatch(getIntlService())
    const prev = intlSelector(getState())
    const next = intlService.mergeIntl(prev, extra)
    if (next === prev) return
    dispatch(intlSlice.set(next))
  })
